module.exports = __webpack_public_path__ + "img/question.6e42d9d6.svg";